import api from '@/lib/api';
import { API_ENDPOINTS } from '@/constants/endpoints';
import type { ApiResponse } from '@/types';

export type AccessTier = 'full_access' | 'read_only' | 'write_only' | 'dev';

export interface ToolClient {
  clientId: string;
  activeKey: string | null;
  accessTier: AccessTier;
  activeKeyExpiresAt: string | null;
  createdAt: string;
  updatedAt: string;
}

export interface ToolClientsListResponse {
  clients: ToolClient[];
  pagination: { page: number; limit: number; total: number; totalPages: number };
}

export const toolClientService = {
  async list(params?: { page?: number; limit?: number; search?: string }) {
    const response = await api.get<ApiResponse<ToolClientsListResponse>>(
      API_ENDPOINTS.TOOL_CLIENTS.BASE,
      { params }
    );
    return response.data.data;
  },

  async create(data: { clientId: string; accessTier?: AccessTier }) {
    const response = await api.post<ApiResponse<ToolClient>>(
      API_ENDPOINTS.TOOL_CLIENTS.BASE,
      data
    );
    return response.data.data;
  },

  async updateTier(clientId: string, accessTier: AccessTier) {
    const response = await api.patch<ApiResponse<ToolClient>>(
      API_ENDPOINTS.TOOL_CLIENTS.TIER(clientId),
      { accessTier }
    );
    return response.data.data;
  },

  async rotateKey(clientId: string) {
    const response = await api.post<ApiResponse<ToolClient>>(
      API_ENDPOINTS.TOOL_CLIENTS.ROTATE(clientId)
    );
    return response.data.data;
  },

  async delete(clientId: string) {
    await api.delete(API_ENDPOINTS.TOOL_CLIENTS.BY_ID(clientId));
  },
};
